import React from 'react';
import styles from './Step3Nimbus.module.scss';
import posed from 'react-pose';
import classNames from 'classnames';

const delay = 1400;
const duration = 1500;

const Path = posed.path({
    enter: {
        opacity: 1,
        pathLength: 100,
        pathOffset: 0,
        applyAtEnd: {opacity: 0},
        delay,
        transition: {
            opacity: {duration: 0},
            pathLength: () => ({
                type: 'keyframes',
                values: [0, 100, 100, 100],
                times: [0, 0.3, 0.6, 1],
                duration,
            }),
            pathOffset: () => ({
                type: 'keyframes',
                values: [0, 0, 0, 100],
                times: [0, 0.3, 0.6, 1],
                duration,
            }),
        },
    },
    exit: {
        pathLength: 100,
        pathOffset: 0,
        opacity: 0,
        transition: {duration: 0},
    },
});

const Line = ({path}) => (
    <Path stroke='#e10097' strokeWidth='6' strokeLinecap='round' d={path} />
);

export default function Step3Nimbus({className}) {
    return (
        <svg className={className} width='367' height='108' viewBox='0 0 367 108'>
            <Line path='M39 89 L10 65' />
            <Line path='M85 59 L72 21' />
            <Line path='M143 63 L136 24' />
            <Line path='M207 46 L207 9' />
            <Line path='M261 57 L290 21' />
            <Line path='M297 98 L340 81' />
        </svg>
    );
}
